import React from 'react';
import PropTypes from 'prop-types';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import InfoIcon from '@material-ui/icons/Info';
import { Button } from "@material-ui/core";

import './AlertsCard.css';
import CancelIcon from "@mui/icons-material/Cancel";

class AlertsCard extends React.PureComponent {
  state = {
    snoozeDuration: 1,
    showSnooze: false,
  };

  renderIcon = () => {
    const { classification } = this.props.alertEntry;
    switch (classification) {
      case 'info':
        return <InfoIcon style={{ fontSize: 24, color: '#2196f3' }} />;
      case 'critical':
        return <InfoIcon style={{ fontSize: 24, color: '#f44336' }} />;
      case 'warning':
        return <InfoIcon style={{ fontSize: 24, color: '#ff9800' }} />;
      default:
        return <InfoIcon style={{ fontSize: 24 }} />;
    }
  };


  handleResolve = () => {
    const { alertId } = this.props.alertEntry;
    this.props.resolveAlert(alertId );
    this.setState({ showSnooze: false });
    // this.props.removeSnoozedAlert();
  };


  render() {
    const { alertEntry } = this.props;
    const { timestamp, alertMessage, identifier } = alertEntry;
    const { showSnooze } = this.state;

    return (
      <Card className="alerts-card">
        <div className="card-header alerts-card-header">
          <div className="alert-title">
            <div>{this.renderIcon()}</div>
            <div style={{ width: '100%' }}>
              <p className="alert-title-text">{alertMessage}</p>
              <p className="alert-timestamp">
                <b>{identifier.userName} -</b> {timestamp}
              </p>
            </div>
                {(this.props.user.companyIds && this.props.user.companyIds.length > 0) && (
                  <div style={{ marginLeft: '-16px' }}>
                    <CancelIcon
                      style={{
                        visibility: this.state.showSnooze ? 'hidden' : 'visible',
                      }}
                      className="snooze-icon"
                      onClick={() => this.setState({ showSnooze: true })}
                    />
                  </div>
                )}
          </div>
        </div>

        {showSnooze && (
          <CardContent>
            <div className="snooze-row">

              <Button
                variant="contained"
                onClick={() => this.setState({ showSnooze: false })}
                style={{
                  width: '100px',
                  marginRight: '16px',
                  marginBottom: '16px',
                }}
              >
                No
              </Button>


                <Button
                  variant="contained"
                  onClick={this.handleResolve}
                  style={{
                    width: '100px',
                    marginRight: '16px',
                    marginBottom: '16px',
                    color: 'white',
                    backgroundColor: 'darkred',
                  }}
                >
                  Delete
                </Button>

            </div>
          </CardContent>
        )}
      </Card>
    );
  }
}

AlertsCard.propTypes = {
    alertEntry: PropTypes.object.isRequired,
    snoozeAlert: PropTypes.func,
    removeSnoozedAlert: PropTypes.func
};

export default AlertsCard;
